import { useTranslation } from "react-i18next";
import SurveyStatus, { SurveyStatusMainText, SurveyStatusSubText } from "./SurveyStatus";

export function SurveyLoading() {
    const { t } = useTranslation();
    return (
        <SurveyStatus>
            <SurveyStatusMainText>{t("surveyResponse.loading")}</SurveyStatusMainText>
        </SurveyStatus>
    );
}

export function SurveyAlreadyCompleted() {
    const { t } = useTranslation();
    return (
        <SurveyStatus>
            <SurveyStatusMainText>{t("surveyResponse.alreadyAnsweredTitle")}</SurveyStatusMainText>
            <SurveyStatusSubText>{t("surveyResponse.alreadyAnsweredText")}</SurveyStatusSubText>
        </SurveyStatus>
    );
}

export function SurveyNotActive() {
    const { t } = useTranslation();
    return (
        <SurveyStatus>
            <SurveyStatusMainText>{t("surveyResponse.surveyNotActiveTitle")}</SurveyStatusMainText>
            <SurveyStatusSubText>{t("surveyResponse.surveyNotActiveText")}</SurveyStatusSubText>
        </SurveyStatus>
    );
}

export function SurveyMissing() {
    const { t } = useTranslation();
    return (
        <SurveyStatus>
            <SurveyStatusMainText>{t("surveyResponse.couldNotGetSurvey")}</SurveyStatusMainText>
        </SurveyStatus>
    );
}

export function SurveyHasNoQuestions() {
    const { t } = useTranslation();
    return (
        <SurveyStatus>
            <SurveyStatusMainText>{t("surveyResponse.noQuestions")}</SurveyStatusMainText>
        </SurveyStatus>
    );
}
